import type { ReactNode } from 'react';
import { HeadContent, Outlet, Scripts, createRootRoute } from '@tanstack/react-router';
import A2UINotFoundPage from '@/a2ui/router/A2UINotFoundPage';
import NavigationProgress from '@/components/NavigationProgress';
import globalCss from '@/styles/global.css?url';
import '@/styles/global.css';
import 'virtual:uno.css';

export const Route = createRootRoute({
  head: () => ({
    meta: [{ charSet: 'utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }, { title: 'Macaron A2UI Workbench' }],
    links: [{ rel: 'stylesheet', href: globalCss }],
  }),
  component: RootComponent,
  notFoundComponent: A2UINotFoundPage,
});

function RootComponent() {
  return (
    <RootDocument>
      <NavigationProgress />
      <Outlet />
    </RootDocument>
  );
}

function RootDocument({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  );
}
